import React from 'react';
import { styled, alpha } from '@mui/material/styles';
import {
  AppBar,
  Menu,
  MenuItem,
  AULA_PROFILE_MENU_BG_COLOUR,
} from '@ublend-npm/aulaui-core';

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100vw',
  '& .MuiToolbar-root': {
    [`@media (max-width: ${theme.breakpoints?.values.sm}px)`]: {
      '& .MuiIconButton-root': {
        padding: 8,
      },
    },
  },
}));

export const AulaLogoContainer = styled.div`
  padding-left: 8px;
  height: 50px;
  width: auto;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserBarContainer = styled.div`
  position: relative;
  z-index: 1100;
`;

export const StyledMenu = styled(Menu)`
  .MuiPaper-root {
    max-width: 280px;
    background-image: none;
    background-color: ${({ theme, isDarkMode }) =>
      isDarkMode ? AULA_PROFILE_MENU_BG_COLOUR : theme.palette.common.white};
    color: ${({ theme, isDarkMode }) =>
      isDarkMode ? theme.palette.common.white : theme.palette.common.black};
    .MuiSvgIcon-root {
      fill: ${({ theme, isDarkMode }) =>
        isDarkMode ? theme.palette.common.white : theme.palette.common.black};
    }
    .MuiTypography-subtitle1 {
      font-weight: 500;
    }
    .MuiTypography-body2 {
      overflow-wrap: anywhere;
    }
    .MuiList-root {
      max-width: 280px;
    }
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  &:hover {
    background-color: ${({ theme }) => theme.palette.action.hover};
  }
`;

export const MUIStyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'center',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'center',
      horizontal: 'left',
    }}
    sx={{ ml: '0.5rem' }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginRight: theme.spacing(1),
    minWidth: 280,
    color: 'inherit',
    backgroundColor: theme.palette.mode === 'dark' ? '#2E2E2E' : '#ffffff',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '8px 0',
    },
    '& .MuiMenuItem-root': {
      padding: '0px',
      width: '280px',
      // height: '36px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .MuiSvgIcon-root': {
        fontSize: 24,
        color: theme.palette.text.secondary,
      },
      '&:hover': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.hoverOpacity
        ),
      },
    },
  },
}));
export const StyledNotificationsMenu = styled(Menu)`
  margin-top: 24px;
  margin-right: 24px;
  overflow: hidden;
  .MuiPaper-root {
    overflow: hidden;
    max-width: 600px;
    width: 85vw;
    background-image: none;
    color: ${({ theme, isDarkMode }) =>
      isDarkMode ? theme.palette.common.white : theme.palette.common.black};
    .MuiSvgIcon-root {
      fill: ${({ theme, isDarkMode }) =>
        isDarkMode ? theme.palette.common.white : theme.palette.common.black};
    }
    .MuiList-root {
      padding-top: 0;
    }
  }
`;
